import { Box, Theme, makeStyles, Typography, Paper } from "@material-ui/core";
import InsiderBenefits from "./InsiderBenefits";
import BetaForm from "./BetaForm";
import Footer from "./Footer";
import { FormattedMessage } from "react-intl";
import logo from "assets/solveiq_logo.png";

//#region component styles
const useStyles = makeStyles((theme: Theme) => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    background: "#ffffff",
  },

  title: {
    fontWeight: 700,
    fontSize: "32px",
    color: "#ffffff",
    textAlign: "center",
  },

  subtitle: {
    color: "#ffffff",
    textAlign: "center",
    marginTop: "5px",
  },

  textContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "30px",
  },

  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "30px",
    padding: "35px",

    [theme.breakpoints.down("md")]: {
      width: "331px",
    },
    [theme.breakpoints.up("md")]: {
      width: "684px",
    },
    [theme.breakpoints.up("lg")]: {
      width: "940px",
    },
    // this should technically be "1200px", but we don't have a breakpoint for 1920+ yet
    [theme.breakpoints.up("xl")]: {
      width: "1024px",
    },
  },

  // this is the gradient that sits below the header gutter and acts
  // as the content gutter. This is gradient is designed to transition
  // seamlessly to the background color.
  gradientBacker: {
    background: "linear-gradient(#EFEFEF, #FFFFFF)",
    height: "639px",
    [theme.breakpoints.up("lg")]: {
      height: "413px",
    },
  },

  backgroundHeader: {
    height: "292px",
    background:
      "transparent linear-gradient(2deg, #00CACD 0%, #0080A2 100%) 0% 0% no-repeat padding-box",
  },
  foregroundRoot: {
    position: "absolute",
    left: 0,
    right: 0,
    margin: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: "15px",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  contentTitle: {},
  titleBar: {
    display: "flex",
    alignItems: "center",
    alignSelf: "stretch",
    background: "#F7F8FA",
    height: "43px",
    paddingLeft: "20px",
    [theme.breakpoints.down("md")]: {
      height: "56px",
    },
  },
}));
//#endregion component styles

const BetaSignUp: React.FC = () => {
  const classes = useStyles();
  return (
    <Box data-qatag="signup.root" className={classes.root}>
      <Box
        data-qatag="signup.backgroundheader"
        className={classes.backgroundHeader}
      />
      <Box
        data-qatag="signup.backgroundgradient"
        className={classes.gradientBacker}
      />
      <Box
        data-qatag="signup.foregroundroot"
        className={classes.foregroundRoot}
      >
        <Box data-qatag="signup.titlebar" className={classes.titleBar}>
          <img data-qatag="signup.titlebar.logo" src={logo} alt="logo" />
        </Box>
        <Box
          data-qatag="signup.textContainer"
          className={classes.textContainer}
        >
          <Typography
            className={classes.title}
            variant="h2"
            data-qatag="signup.title"
          >
            <FormattedMessage defaultMessage="Still need to fix your issue but don’t want to pay?" />
          </Typography>
          <Typography
            className={classes.subtitle}
            variant="h5"
            data-qatag="signup.subtitle"
          >
            <FormattedMessage defaultMessage="Fix your drivers for FREE, no credit card required!" />
          </Typography>
        </Box>
        <Paper
          data-qatag="signup.paper"
          elevation={0}
          className={classes.paper}
        >
          <Typography
            data-qatag="signup.contenttitle"
            className={classes.contentTitle}
            variant="h5"
            color="primary"
          >
            <FormattedMessage defaultMessage="Get unlimited access to the Solve iQ service for 30 days at no cost*" />
          </Typography>

          <Box
            data-qatag="signup.contentcontainer"
            className={classes.contentContainer}
          >
            <InsiderBenefits data-qatag="insiderBenefits" />
            <BetaForm data-qatag="betaForm" />
          </Box>
          <Footer />
        </Paper>
      </Box>
    </Box>
  );
};

export default BetaSignUp;
